import { OrderFlow } from '../../../../types';
import {
  energyDynamicLarge,
  energyDynamicSmall,
  energyFixLarge,
  energyFixSmall,
} from './PathsForSvgLogos';

type EnergyTariffLogoProps = {
  flow: OrderFlow.energyDynamic | OrderFlow.energyFix;
  size?: Size;
};
type Size = 'small' | 'large';

const energy = {
  energyDynamic: {
    small: energyDynamicSmall,
    large: energyDynamicLarge,
  },
  energyFix: {
    small: energyFixSmall,
    large: energyFixLarge,
  },
};

const sizeVariant = {
  small: '56',
  large: '80',
};

const EnergyTariffLogo = ({ flow, size = 'large' }: EnergyTariffLogoProps) => (
  <svg
    width={sizeVariant[size]}
    height={sizeVariant[size]}
    viewBox={`0 0 ${sizeVariant[size]} ${sizeVariant[size]}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-testid={flow}
    aria-label={flow}
    role="img"
  >
    {energy[flow][size]}
  </svg>
);

export default EnergyTariffLogo;
